import { getOsName } from "@faire/retailer-visitor-shared/lib/user-agent/osName";
import { getIsAppInstalled } from "@faire/retailer-visitor-shared/serialized-data/getIsAppInstalled";
import { getDeepLinkUrl, OSType } from "@faire/retailer-visitor-shared/services/MobileAppBanner";
import { useSettingAppPromotionBannerLinks } from "@faire/retailer-visitor-shared/settings/useSettingAppPromotionBannerLinks";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
export var useGetMobileAppUrl = function(queryParams) {
    var location = useLocation();
    var storeLinks = useSettingAppPromotionBannerLinks();
    var deepLinkUrl = getDeepLinkUrl(location, queryParams);
    var storeLinkUrl = useMemo(function() {
        if (getOsName() === OSType.IOS) {
            var _storeLinks_app_store_link;
            return (_storeLinks_app_store_link = storeLinks.app_store_link) !== null && _storeLinks_app_store_link !== void 0 ? _storeLinks_app_store_link : "";
        } else if (getOsName() === OSType.ANDROID) {
            var _storeLinks_play_store_link;
            return (_storeLinks_play_store_link = storeLinks.play_store_link) !== null && _storeLinks_play_store_link !== void 0 ? _storeLinks_play_store_link : "";
        }
        return "";
    }, [
        storeLinks.app_store_link,
        storeLinks.play_store_link
    ]);
    var ctaUrl = useMemo(function() {
        return !!getIsAppInstalled() && deepLinkUrl || storeLinkUrl;
    }, [
        deepLinkUrl,
        storeLinkUrl
    ]);
    return ctaUrl;
};
